import { APIError } from '../../constants/errorCode/system';
import baseServices from '../baseServices';
import httpHelper from '../../helpers/httpHelper';
import api from '../../common/api';

const ztlServicesV2 = {
  createConsent: async (body) => {
    try {
      const url = api.ztlV2.createConsent;
      const data = await baseServices.postDataToken(url, body);
      return await data.json();
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  renewConsent: async ({ consentId, callbackUrl, accountOwnerSsn, debtorBankBic, bankBranch }) => {
    try {
      const url = api.ztlV2.renewConsent.replace(':consentId', consentId);
      const response = await baseServices.putDataToken(url, {
        callbackUrl,
        accountOwnerSsn,
        debtorBankBic,
        ...(bankBranch && { bankBranch }),
      });
      const result = await response.json();

      // Handle non-200 status codes
      if (!response.ok) {
        return {
          success: false,
          code: response.status,
          errors: result.errors || [],
          ...(result.message && {
            message: result.message,
          }),
        };
      }
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  scaSuccess: async (body) => {
    try {
      const url = api.ztlV2.scaSuccess;
      const data = await baseServices.putDataToken(url, body);
      return await data.json();
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getConsent: async ({ consentId, companyId }) => {
    try {
      const query = httpHelper.serialize({ companyId });
      const url = api.ztlV2.getConsent.replace(':consentId', consentId) + `?${query}`;
      const response = await baseServices.getDataToken(url);
      const result = await response.json();

      // Handle non-200 status codes
      if (!response.ok) {
        return {
          success: false,
          code: response.status,
          errors: result.errors || [],
          ...(result.message && {
            message: result.message,
          }),
        };
      }
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getSupportedBanks: async ({ countryCode }) => {
    try {
      const queryParams = httpHelper.serialize({ countryCode });
      const url = api.ztlV2.supportedBankByCountry.replace(':countryCode', countryCode) + '?' + queryParams;
      const data = await baseServices.getDataToken(url);
      return await data.json();
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getProgressPdf: async ({ paymentId }) => {
    try {
      const url = api.ztlV2.progressPdf.replace(':paymentId', paymentId);
      const response = await baseServices.getDataToken(url);
      const blob = await response.blob();
      return blob;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
};

export default ztlServicesV2;
